import { Box, CircularProgress, Modal } from "@mui/material";
import { useEffect, useState } from "react";
import Styles from './style.module.css';
// import { setUserData } from "../redux/userSlice";
import { useDispatch } from "react-redux";
import Toastify from "../container/helper/Toastify";
import api from "../container/helper/Api";
import { setLogin } from "../container/redux/userSlice";
import { setRegister } from "../container/redux/registerStudentSlice";
import { useNavigate } from "react-router-dom";

const RegistrationModal = ({ closeModal, open, desc, data }) => {
  const navigate = useNavigate()
  const [emailOtp, setEmailOtp] = useState("");
  const [mobileOtp, setMobileOtp] = useState("");
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const [resendLoading, setResendLoading] = useState(false)
  const [resendTimer, setResendTimer] = useState(60)

  const Data = data

  useEffect(() => {
    if (open) setResendTimer(60)
  }, [open])

  useEffect(() => {
    if (!open || resendTimer <= 0) return
    const id = setTimeout(() => setResendTimer((t) => t - 1), 1000)
    return () => clearTimeout(id)
  }, [open, resendTimer])

  const handleResendOtp = async () => {
    if (resendTimer > 0 || resendLoading) return
    try {
      setResendLoading(true)
      const { status } = await api.resendOtp({ email: Data?.email, phone: Data?.phone })
      if (status === 200) {
        Toastify.success("OTP resent successfully")
        setEmailOtp("")
        setMobileOtp("")
        setResendTimer(60)
      }
    } catch (error) {
      Toastify.error(error.response?.data?.message || "Failed to resend OTP")
    } finally {
      setResendLoading(false)
    }
  }


  const styles = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "white",
    border: "none",
    padding: "27px 0px",
    height: "fit-content",
    display: "block",
    width: '600px',
    borderRadius: '7px',
    "&:focus": {
      outline: "none",
    },
  };

  const handleSubmit = async () => {
    // console.log("OTP Submitted:", otp);
    console.log("hlo");

    if (emailOtp.length === 4 && mobileOtp.length === 6) {
      console.log("hy");

      try {
        setIsLoading(true)
        const { data, status } = await api.verifyRegisterStudent({ otp: emailOtp, mobileOtp, ...Data })

        if (status === 200) {
          dispatch(setRegister(true))
          Toastify.success("Student Registered successfully");
          console.log("data reg", data.data)
          localStorage.setItem("token", data.data.token)
          setEmailOtp("")
          setMobileOtp("")
          closeModal()
          navigate('/courses/Courses');

        }
      } catch (error) {
        Toastify.error(error.response.data.message || `something went wrong`);
        // closeModal()
      }
      finally {
        setIsLoading(false)
      }
    } else {
      console.log("not clicked");

    }


  };

  // const handleSubmit=async()=>{
  //   console.log("hy");

  // }

  return (
    <Modal
      open={open}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={styles}>
        <div
          className={Styles.entryView}
          style={{
            paddingLeft: 20,
            paddingRight: 20,
            flexDirection: "column",
          }}
        >
          <div className={Styles.headingText} style={{ textAlign: "center" }}>
            Enter Your OTP
          </div>

          <div className={Styles.lineStyle} style={{ width: "100%" }} />
          {desc && (

            <div className={Styles.descStyle}>
              {/* We have sent you an OTP to your vy***@gmail.com, please check and verify. */}
              {desc}

            </div>
          )}

          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <input
              type="text"
              placeholder="Enter 4-digit Email OTP..."
              value={emailOtp}
              onChange={(e) => {
                const input = e.target.value;
                if (/^\d{0,4}$/.test(input)) setEmailOtp(input);
              }}
              className={Styles.otpInput}
            />

            <input
              type="text"
              placeholder="Enter 6-digit Mobile OTP..."
              value={mobileOtp}
              onChange={(e) => {
                const input = e.target.value;
                if (/^\d{0,6}$/.test(input)) setMobileOtp(input);
              }}
              className={Styles.otpInput}
            />
          </div>

          <div style={{ textAlign: "center", marginTop: 14, fontSize: 14, color: "#666" }}>
            Didn't receive OTP?{" "}
            {resendTimer > 0 ? (
              <span style={{ color: "#999" }}>Resend in {resendTimer}s</span>
            ) : (
              <span
                onClick={handleResendOtp}
                style={{
                  color: "#1D83F8",
                  fontWeight: 500,
                  textDecoration: "underline",
                  cursor: resendLoading ? "not-allowed" : "pointer",
                }}
              >
                {resendLoading ? "Sending..." : "Resend OTP"}
              </span>
            )}
          </div>

          <div className={Styles.buttons}>
            <div onClick={closeModal} className={Styles.cancelStyle} style={{ cursor: "pointer" }}>
              Cancel
            </div>
            {/* <div
            //   onClick={otp.length === 4 ? handleSubmit : null}
             onClick={() => {
                handleSubmit();
              }}
              className={`${Styles.deleteStyle} ${
                otp.length !== 4 ? Styles.disabled : ""
              }`}
              style={{
                cursor: otp.length === 4 ? "pointer" : "not-allowed",
                opacity: otp.length === 4 ? 1 : 0.6,
              }}
            > */}
            <div
              onClick={() => {
                handleSubmit();
              }}
              className={`${Styles.deleteStyle}`}
              style={{
                cursor: emailOtp.length === 4 && mobileOtp.length === 6 ? "pointer" : "not-allowed",
                opacity: emailOtp.length === 4 && mobileOtp.length === 6 ? 1 : 0.6,
              }}
            >
              {isLoading ? <CircularProgress size="30px" color="inherit" /> : `Submit`}
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default RegistrationModal 
